export default __webpack_public_path__ + "static/media/gaming_Footer_CQ9_Supplier.aee78ac1.svg";